var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressStatusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48787 11.7512C1.75909 10.6825 1.33301 9.39086 1.33301 7.99974C1.33301 4.3178 4.3178 1.33301 7.99974 1.33301C11.0228 1.33301 13.5759 3.34511 14.3928 6.10313C13.9405 6.94407 13.1011 7.97326 11.7671 8.92385V4.83998C11.7671 4.53316 11.5184 4.28442 11.2116 4.28442H10.2914C9.9846 4.28442 9.73586 4.53287 9.73586 4.8397V9.38864C9.73586 9.87856 9.56792 10.131 9.41338 10.2436C9.27234 10.3052 9.12811 10.3656 8.98065 10.4246V6.22889C8.98065 5.92206 8.73191 5.67333 8.42509 5.67333H7.50494C7.19811 5.67333 6.94938 5.92041 6.94938 6.22724V10.3088C6.94938 10.8109 6.77297 11.0635 6.61538 11.1719C6.46301 11.2087 6.30814 11.244 6.15076 11.2779V7.60911C6.15076 7.30228 5.90203 7.05355 5.5952 7.05355H4.67505C4.36822 7.05355 4.11949 7.30115 4.11949 7.60798V10.7775C4.11949 11.2976 3.93026 11.55 3.7687 11.6518C3.36364 11.6936 2.94538 11.7265 2.51359 11.7498C2.505 11.7502 2.49643 11.7507 2.48787 11.7512Z",
    fill: "url(#paint0_linear_1218_24613)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99945 14.6667C11.6814 14.6667 14.6662 11.6819 14.6662 7.99994C14.6662 7.7932 14.6568 7.58866 14.6383 7.38672C12.7392 11.0766 6.84037 12.8807 4.00635 13.3385C4.02852 13.3405 3.9843 13.3366 4.00635 13.3385C5.11885 14.1709 6.50315 14.6667 7.99945 14.6667Z",
    fill: "url(#paint1_linear_1218_24613)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1218_24613",
    x1: 14.3928,
    y1: 1.33301,
    x2: 3.35698,
    y2: 10.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27C69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1218_24613",
    x1: 14.6662,
    y1: 7.38672,
    x2: 6.86939,
    y2: 15.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27C69F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressStatusIcon);
export default __webpack_public_path__ + "static/media/addressStatusIcon.948332e32faebbc0cf48390400f06cfc.svg";
export { ForwardRef as ReactComponent };